import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef } from "react";
import { useWindowSize } from "usehooks-ts";
import { MenuElement } from "./MenuElement.js";
import { eramTextDimensionMap } from "../../eramFont.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { baseBorderColor } from "../../colorNameMap.js";
const { height: fontHeight } = eramTextDimensionMap[2];
export const MovableMenu = ({ menuName, title, children, onClose, width, height, zIndex, pos, startDrag, eventMode, ref, showTriangle = false }) => {
    const localRef = useRef(null);
    useCenterCursor(localRef);
    const windowSize = useWindowSize();
    const labelWidth = width - fontHeight;
    const xX = width - fontHeight;
    const x = Math.min(pos.x, windowSize.width - width);
    const y = Math.min(pos.y, windowSize.height - (height + fontHeight + 3));
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    return (_jsxs("container", { ref: localRef, label: menuName, x: x, y: y, sortableChildren: true, zIndex: zIndex, eventMode: eventMode, children: [showTriangle && (_jsx("graphics", { y: 1, zIndex: 4, eventMode: "none", draw: (graphics) => {
                    graphics.clear();
                    graphics.poly([0, 0, 0, fontHeight + 1, fontHeight + 1, 0]).fill({ color: 0xadad00, alpha: 0.5 });
                } })), _jsx(MenuElement, { x: 0, y: 0, width: labelWidth, text: title, onmousedown: startDrag, borderColor: baseBorderColor }), _jsx(MenuElement, { x: xX, y: 0, width: fontHeight, text: "X", onmousedown: onClose, borderColor: baseBorderColor }), _jsxs("container", { x: 0, y: fontHeight + 2, sortableChildren: true, children: [_jsx("graphics", { draw: (graphics) => {
                            graphics.clear();
                            graphics.rect(0, 0, width, height).fill(0).stroke({ width: 1, color: baseBorderColor });
                        } }), children] })] }));
};
//# sourceMappingURL=MovableMenu.js.map